import React from "react";
import SettingCard from "./view/SettingCard";
import SettingList from "./view/settings.json";
import "./Settings.css";
import { Card } from "react-bootstrap";

const SettingsList = () => {
  return (
    <Layout>
      <div className="col-12 stretch-card container-fluid">
        <div className="settingcards_container mb-2">
          {SettingList.map((each) => {
            return (
              <Card>
                <Card.Body>
                  <SettingCard
                    icon={each?.icon}
                    key={each?.id}
                    title={each?.title}
                    subtitle={each?.subtitle}
                    to={each?.to}
                  />
                </Card.Body>
              </Card>
            );
          })}
        </div>
      </div>
    </Layout>
  );
};

export default SettingsList;
